module.exports = __webpack_public_path__ + "static/moneySense-f9950eb537a0a9003acb5196e290d78e.png";